import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Switch } from '../ui/switch';
import { jv, errMsg } from './api';

const NUMS = [
  ['portal_stall_days', 'Client portal counts as stalled after', 'days'],
  ['stage_stall_days', 'Application stuck at one stage after', 'days'],
  ['sign_stall_days', 'E-Sign / ID check outstanding after', 'days'],
  ['popups_per_day', 'Pop-ups per day (urgent only, 0 = off)', ''],
];

export const SettingsDialog = ({ token, open, onClose, settings, onSaved }) => {
  const [s, setS] = useState(settings || {});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setS(settings || {}); }, [open, settings]);
  const save = async () => {
    setBusy(true);
    try { await jv.settings(token, { ...s, ...Object.fromEntries(NUMS.map(([k]) => [k, Number(s[k])])) }); toast.success('Jarvis settings saved'); onSaved(); onClose(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="jv-settings">
        <DialogHeader><DialogTitle>Jarvis settings</DialogTitle><DialogDescription>Applies to everyone in your workspace.</DialogDescription></DialogHeader>
        <div className="space-y-4">
          {[['enabled', 'Monitor the business'], ['ai_enabled', 'AI-written advice and daily brief (also needs approval in Security Centre → Data transfers)']].map(([k, l]) => (
            <label key={k} className="flex items-center justify-between text-sm font-medium">{l}<Switch checked={!!s[k]} onCheckedChange={(v) => setS((x) => ({ ...x, [k]: v }))} data-testid={`jv-set-${k}`} /></label>
          ))}
          {NUMS.map(([k, l, unit]) => (
            <label key={k} className="flex items-center justify-between gap-3 text-sm">{l}
              <span className="flex items-center gap-1.5"><input type="number" min={k === 'popups_per_day' ? 0 : 1} max={60} value={s[k] ?? ''} onChange={(e) => setS((x) => ({ ...x, [k]: e.target.value }))} className="h-9 w-16 rounded-md border border-slate-200 px-2 text-right" data-testid={`jv-set-${k}`} /><span className="w-8 text-xs text-slate-500">{unit}</span></span>
            </label>
          ))}
          <button type="button" disabled={busy} onClick={save} className="cp-dark w-full rounded-xl bg-[#0E1B4D] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#2347FF] disabled:opacity-50" data-testid="jv-settings-save">{busy ? 'Saving…' : 'Save settings'}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;
